import { TAspectRatio } from 'store/types/aiImage'
import AspectRatio1_1Icon from 'assets/svgr-icons/Aspect_Ratio_1_1.svg'
import AspectRatio16_9Icon from 'assets/svgr-icons/Aspect_Ratio_16_9.svg'
import AspectRatio9_16Icon from 'assets/svgr-icons/Aspect_Ratio_9_16.svg'
import AspectRatio2_3Icon from 'assets/svgr-icons/Aspect_Ratio_2_3.svg'
import AspectRatio3_2Icon from 'assets/svgr-icons/Aspect_Ratio_3_2.svg'
import AspectRatio3_4Icon from 'assets/svgr-icons/Aspect_Ratio_3_4.svg'
import AspectRatio4_3Icon from 'assets/svgr-icons/Aspect_Ratio_4_3.svg'
import { AiSparkleIcon } from 'common-components/AiSparkleIcon'

import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'

const getIcon = (aspectRatio: TAspectRatio) => {
  switch (aspectRatio) {
    case '1:1':
      return <AspectRatio1_1Icon />
    case '16:9':
      return <AspectRatio16_9Icon />
    case '9:16':
      return <AspectRatio9_16Icon />
    case '2:3':
      return <AspectRatio2_3Icon />
    case '3:2':
      return <AspectRatio3_2Icon />
    case '3:4':
      return <AspectRatio3_4Icon />
    case '4:3':
      return <AspectRatio4_3Icon />
    case 'auto':
      return <AiSparkleIcon />
  }
}

export const reconstructOptions = (aspectRatios: TAspectRatio[]) => {
  return aspectRatios.map(aspectRatio => ({
    key: aspectRatio,
    label: translate(aspectRatio as T),
    icon: getIcon(aspectRatio)
  }))
}
